import { render, staticRenderFns } from "./AppBreadcrumbs.vue?vue&type=template&id=33261ee0&"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33261ee0')) {
      api.createRecord('33261ee0', component.options)
    } else {
      api.reload('33261ee0', component.options)
    }
    module.hot.accept("./AppBreadcrumbs.vue?vue&type=template&id=33261ee0&", function () {
      api.rerender('33261ee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/widget/AppBreadcrumbs.vue"
export default component.exports